<template>
  <div class="orderdetail-wrap" v-if="detailData">
    <h3>
      <p>{{detailData.status_words || '-'}}</p>
      <van-button type="primary" color="#0294FF" @click="showModal" v-if="detailData.reapply === '1'">重新申请</van-button>
      <van-button type="primary" color="#CCCCCC" disabled v-else-if="detailData.reapply === '2'">已申请</van-button>
      <span v-else></span>
    </h3>
    <div class="orderdetail-manager" v-if="detailData.grab_user && detailData.grab_user.length > 0">
      <div class="orderdetail-manager-wrap">
        <van-image
          round
          :src="detailData.grab_user.head_avatar"
        />
        <div class="manager-info">
          <p>{{detailData.grab_user.name}}</p>
          <p class="ellipsis">{{detailData.grab_user.position}}丨{{detailData.grab_user.company}}</p>
          <p><van-rate color="#FF4B4D" readonly v-model="detailData.grab_user.score" size="15"/><em>{{detailData.grab_user.score}}</em>({{detailData.grab_user.done_number}}单)</p>
        </div>
      </div>
    </div>
    <div class="orderdetail-info">
      <ul>
        <li class="info1">
          <span>{{detailData.username}}</span><em class="colorFEA802" v-if="detailData.own_car === '1'">有车</em><em class="color20C272" v-if="detailData.own_house === '1'">有房</em>
        </li>
        <li class="info2">{{detailData.city}}丨申请时间：{{detailData.created_at}}</li>
        <li class="info3">贷款金额：<span>{{detailData.loan_amount}}万</span></li>
      </ul>
    </div>
    <div class="orderother-info">
      <p><span>工作信息：</span>{{job_info}}</p>
      <p><span>资产信息：</span>{{assets_info}}</p>
    </div>
    <OverlayModal :show="showOverlay"  @closeModal="closeModal" :id="id" :channel_lable="channel_lable"/>
  </div>
</template>
<script>
import { Image as VanImage, Rate, Button } from 'vant';
import { mapActions, mapState } from 'vuex';
import OverlayModal from './overlayModal';
export default {
  name: 'OrderDetail',
  data() {
    return {
      rateData: 5,
      showOverlay: false,
      channel_lable: this.$route.query.channel_lable,
      id: this.$route.query.id,
      job_info: '',
      assets_info: ''
    }
  },
  created() {
    this.fetchDetail({
      request: 'loan/myorderdetail',
      path: 'loan/myorderdetail',
      data: {id: this.id, channel_id: this.channel_lable},
      onSuccess: () => {
        this.job_info = Object.values(this.detailData.job_info).join('，')
        this.assets_info = Object.values(this.detailData.assets_info).join('，')
      }
    })
  },
  methods: {
    ...mapActions(['fetchDetail']),
    showModal() {
      this.showOverlay = true
    },
    closeModal(value) {
      this.showOverlay = value
    },
  },
  computed: {
    ...mapState({
      detailData(state) {
        return state.detail['loan/myorderdetail'].data
      }
    }),
  },
  components: {
    [VanImage.name]: VanImage,
    [Rate.name]: Rate,
    [Button.name]: Button,
    [OverlayModal.name]: OverlayModal
  }
}
</script>